import type { Beat } from '@/features/landing/walk/walk'

// Number, title, one sentence per beat; the number is drawn by the
// caption's BeatIndex, the words by the caption's live region.
export const CAPTIONS: Record<Beat, { title: string; line: string }> = {
    1: {
        title: 'Read the story.',
        line: 'Every frame pairs a kanji with one keyword and one short story — Kanjido’s own, in the app’s own prose.',
    },
    2: {
        title: 'Draw it from the keyword.',
        line: 'The English word and the stroke order are shown; the square is yours. Producing the shape by hand is the method.',
    },
    3: {
        title: 'Checked for you.',
        line: 'A grader compares your strokes with the canonical ones and marks it. You never grade yourself.',
    },
    4: {
        title: 'Recall tested every five.',
        line: 'The kanji, and you name its keyword. A miss re-queues until you have named it.',
    },
    5: {
        title: 'Fifteen frames, one sitting.',
        line: 'Lesson 1 is numerals, mouth, day, month, rice field and eye — the shapes the rest leans on.',
    },
    6: {
        title: 'Where you stand.',
        line: 'The product tells you, in its own words. This is what it says after Lesson 1.',
    },
}
